import React, { useEffect, useState, createContext } from 'react';

export const detailsContext = createContext();

export default function DetailsProvider({ children }) {
  const [mounted, setMounted] = useState(false);
  const [contentTitlesObject, setContentTitleObject] = useState([]);

  useEffect(() => {
    setMounted(true);
  }, []);

  const idGenerator = (title) => {
    if (title?.includes('/')) {
      let id = title.slice(title.indexOf('/'));
      return id?.replaceAll(' ', '-').toLowerCase();
    } else {
      return title?.replaceAll(' ', '-').toLowerCase();
    }
  };

  const addTitle = (title) => {
    setContentTitleObject((currentValue) => [
      ...currentValue,
      {
        displayText: title,
        id: idGenerator(title),
      },
    ]);
  };

  if (!mounted) {
    return <></>;
  }
  return (
    <detailsContext.Provider
      value={{ contentTitlesObject, addTitle, idGenerator }}
    >
      {children}
    </detailsContext.Provider>
  );
}